var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStarSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#050505;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,20.6c-0.2,0-0.3,0-0.5-0.1L12,18.1l-4.5,2.4c-0.3,0.2-0.7,0.1-1.1-0.1c-0.3-0.2-0.5-0.6-0.4-1l0.9-5 l-3.6-3.5C3,10.7,2.9,10.3,3,9.9c0.1-0.4,0.4-0.6,0.8-0.7l5-0.7l2.2-4.5c0.2-0.3,0.5-0.6,0.9-0.6l0,0c0.4,0,0.7,0.2,0.9,0.6 l2.2,4.5l5,0.7c0.4,0.1,0.7,0.3,0.8,0.7c0.1,0.4,0,0.8-0.3,1l-3.6,3.5l0.9,5c0.1,0.4-0.1,0.8-0.4,1C17.4,20.5,17.2,20.6,16.9,20.6z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarSolid);
export default __webpack_public_path__ + "static/media/icon-star-solid.39bbb3ccae7b21961098088764638d71.svg";
export { ForwardRef as ReactComponent };